import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-refundBack`;

const getRefundBackList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/redeemed`, data);
};

const postRefundBack = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/refundBack`, data);
};

export default {
	getRefundBackList,
	postRefundBack,
};
